<template>
    <div class="h-full" ref="map"></div>
</template>

<script>
/* global google */
import bus from "@/bus";

export default {
  props: ["latitude", "longitude", "color"],

  mounted() {
    if (google.maps) {
      this.initMap();
    }

    bus.$on("googleMapsLoaded", this.initMap);
  },

  beforeDestroy() {
    bus.$off("googleMapsLoaded", this.initMap);
  },

  methods: {
    initMap() {
      let googleMap = new google.maps.Map(this.$refs.map, {
        center: {
          lat: this.latitude,
          lng: this.longitude
        },
        zoom: 15,
        disableDefaultUI: true,
        styles: [
          {
            featureType: "administrative",
            elementType: "all",
            stylers: [{ hue: "#4dc0b5" }]
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [{ hue: "#4dc0b5" }]
          }
        ]
      });

      var icon = {
        path:
          "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
        fillColor: this.color,
        fillOpacity: 1,
        anchor: new google.maps.Point(0, 0),
        strokeWeight: 0,
        scale: 1
      };

      new google.maps.Marker({
        position: {
          lat: this.latitude,
          lng: this.longitude
        },
        map: googleMap,
        icon: icon
      });
    }
  }
};
</script>

<style>
.gmnoprint a,
.gmnoprint span {
  display: none;
}
.gmnoprint div {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue